export default __webpack_public_path__ + "static/media/sts.8042136e.png";